import {combineReducers} from "redux";
import {configureStore} from "@reduxjs/toolkit";
import authReducer from "../features/auth/model/slice";
import MessageReducer from "../features/messages/model/slice";
import usersReducer from "../features/users/model/slice";
import companiesReducer from "../features/companies/model/slice";
import filesReducer from "../features/files/model/slice";
import emailVerificationReducer from "../features/email_verification/model/slice";
import passwordReset from "../features/password_reset/model/slice";
import chatReducer from "../features/chat/model/slice";
import boardReducer from "../features/board/model/slice";
import emojiReducer from "../features/emoji/model/slice";
import backupReducer from "../features/backup/model/slice";
import statsReducer from "../features/stats/model/slice";

const rootReducer = combineReducers({
    message: MessageReducer,
    auth: authReducer,
    users: usersReducer,
    files: filesReducer,
    companies: companiesReducer,
    emailVerification: emailVerificationReducer,
    passwordReset: passwordReset,
    board: boardReducer,
    chat: chatReducer,
    emoji: emojiReducer,
    backup: backupReducer,
    stats: statsReducer,
});

const isProduction = process.env.NODE_ENV === 'production';

export const setupStore = () => {
    return configureStore({
        reducer: rootReducer,

        devTools: isProduction
            ? false
            : {
                maxAge: 30,
            },
    });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];
